// src/components/settings/sections/ContactDetailsSection.jsx
import React from 'react';
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FormInput from '../../inputs/FormInput';
import { getAccordionStyles } from './accordionStyles';

const ContactDetailsSection = ({
    expanded,
    handleAccordionChange,
    isDark,
    formData,
    handleTextChange,
}) => {
    const { accordionBaseSx, summarySx, detailsSx } = getAccordionStyles(isDark);

    return (
        <Accordion
            expanded={expanded === 'contact'}
            onChange={handleAccordionChange('contact')}
            disableGutters
            elevation={0}
            square={false}
            sx={accordionBaseSx}
        >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: isDark ? '#93C5FD' : '#1D4ED8' }} />}
                sx={summarySx}
            >
                <Typography fontWeight={600} sx={{ color: isDark ? '#E5E7EB' : '#0F172A', fontSize: 15 }}>
                    Contact Details
                </Typography>
            </AccordionSummary>
            <AccordionDetails sx={detailsSx}>
                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mt: 1 }}>
                    <Box sx={{ flex: 1, minWidth: 220 }}>
                        <FormInput
                            type="text"
                            name="tel1"
                            label="Telephone 1"
                            labelBio="Primary phone number"
                            value={formData.tel1}
                            onChange={handleTextChange}
                            fullWidth
                            required={false}
                        />
                    </Box>
                    <Box sx={{ flex: 1, minWidth: 220 }}>
                        <FormInput
                            type="text"
                            name="tel2"
                            label="Telephone 2"
                            labelBio="Secondary phone number"
                            value={formData.tel2}
                            onChange={handleTextChange}
                            fullWidth
                            required={false}
                        />
                    </Box>
                    <Box sx={{ flex: 1, minWidth: 220 }}>
                        <FormInput
                            type="text"
                            name="email"
                            label="Email"
                            labelBio="Contact email"
                            value={formData.email}
                            onChange={handleTextChange}
                            fullWidth
                            required={false}
                        />
                    </Box>
                    <Box sx={{ flex: 1, minWidth: 220 }}>
                        <FormInput
                            type="text"
                            name="whatsapp_number"
                            label="Whatsapp Number"
                            labelBio="Whatsapp contact number"
                            value={formData.whatsapp_number}
                            onChange={handleTextChange}
                            fullWidth
                            required={false}
                        />
                    </Box>
                </Box>
            </AccordionDetails>
        </Accordion>
    );
};

export default ContactDetailsSection;
